import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  IconButton,
  InputAdornment,
  InputLabel,
  FilledInput,
  FormControl,
  Theme,
  Snackbar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Send } from '@material-ui/icons';
import clsx from 'clsx';

import menus from '../config/menus';
import { subscribeEmail } from '../services/news';
import { Alert } from '@material-ui/lab';
import Logo from './Logo';

interface ISnackbarState {
  open: boolean;
  severity: 'error' | 'warning' | 'info' | 'success' | undefined;
  message: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    padding: `32px 16px`,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: `16px 16px`,
    },
  },
  footer: {
    backgroundColor: '#2A2731',
    minHeight: 200,
  },
  input: {
    color: '#FFF',
  },
  link: {
    color: '#FFF',
    '&:link': {
      textDecoration: 'none',
    },
  },
  menuList: {
    '& > *': {
      marginBottom: 8,
    },
  },
}));
const subscribedMessage = 'ลงทะเบียนรับข่าวสารสำเร็จ';
const Footer = () => {
  const { column, footer, input, link, menuList } = useStyles();
  const [email, setEmail] = useState<string>('');
  const [snackbarState, setSnackbarState] = useState<ISnackbarState>({
    open: false,
    severity: undefined,
    message: '',
  });
  const handleSubscribeEmail = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    const error = await subscribeEmail(email.trim());
    const isSuccess = error === undefined;
    isSuccess && setEmail('');
    setSnackbarState({
      open: true,
      message: isSuccess ? subscribedMessage : error + '',
      severity: isSuccess ? 'success' : 'error',
    });
  };

  const handleEmailTextFieldChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.persist();
    setEmail(event.target.value);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  return (
    <div className={footer}>
      <Container maxWidth='md'>
        <Box display={{ xs: 'block', sm: 'flex' }}>
          <div className={column}>
            <div style={{ display: 'flex' }}>
              <Logo />
            </div>
            <Box height={16} />
            <div>
              การสำรองข้อมูลหลาย ๆ ครั้งหลาย ๆ แห่ง
              เป็นการลดความเสี่ยงในการสูญเสียข้อมูลในแฟ้มข้อมูลนั้น
            </div>
            <Box height={16} />
          </div>
          <div className={clsx(column, menuList)}>
            {menus.map((menu, index) => (
              <Link key={index} className={link} to={menu.link}>
                {menu.text}
              </Link>
            ))}
          </div>
          <div className={column}>
            <div>ลงทะเบียนรับข่าวสาร</div>
            <Box height={8} />
            <form onSubmit={handleSubscribeEmail} onKeyPress={handleKeyPress}>
              <FormControl variant='filled'>
                <InputLabel>อีเมล</InputLabel>
                <FilledInput
                  classes={{ input }}
                  fullWidth
                  required
                  type='email'
                  onChange={handleEmailTextFieldChange}
                  value={email}
                  endAdornment={
                    <InputAdornment position='end'>
                      <IconButton
                        type='submit'
                        color='secondary'
                        disabled={email === ''}
                      >
                        <Send />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </form>
            <Box mt={1} display='flex'>
              <img
                src='/images/A5.png'
                alt='logo-a5'
                style={{ height: 50, width: 31.12 }}
              />
              <Box ml={1}>
                <img
                  src='/images/logo-BTFP-Thai-Sky.png'
                  alt='logo-thai-sky'
                  style={{ height: 50, width: 50 }}
                />
              </Box>
            </Box>
          </div>
          <Snackbar
            open={snackbarState.open}
            autoHideDuration={2000}
            onClose={() =>
              setSnackbarState((state) => ({ ...state, open: false }))
            }
          >
            <Alert severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </Snackbar>
        </Box>
      </Container>
    </div>
  );
};

export default Footer;
